import { text } from './text';

export const green = {
  50: '#e4fbed',
  100: '#bef5d3',
  200: '#90eeb7',
  300: '#51e898',
  400: '#00e17f',
  500: '#00d869',
  600: '#00c75e',
  700: '#1bb563',
  800: '#00a145',
  900: '#008030',
  contrastText: text.contrast,
};
